import { enableCalendarModuleCommandingHotkeys } from '../utils/bindCalendarModuleCommandingHotKeys';
import { enableCalendarModuleHotkeys } from '../utils/bindCalendarModuleHotKeys';
import { enableAppModuleHotkeys } from 'owa-app-module/lib/utils/moduleHotKeys';
import { onResetModuleCommand } from 'owa-calendar-module-command';
import { orchestrator } from 'satcheljs';

orchestrator(onResetModuleCommand, () => {
    // re-enable the global hotkeys now that the popup is closing
    enableCalendarModuleHotkeys();
    enableCalendarModuleCommandingHotkeys();
    enableAppModuleHotkeys();
});
